import { TenantsDrawer } from '../../../home/components/homepage/TenantsDrawer/TenantsDrawer';
import { InviteDetailsDrawer } from '../../../members/components/table/InviteDetailsDrawer';
import { InviteDrawer } from '../../../members/components/table/InviteDrawer';
import AddConnectionDrawer from 'features/sso/add-connection-drawer';
import { HelpDrawerController } from 'features/main/components/HelpDrawerController';
import SSOSamlConnectionModal from 'features/sso/saml/sso-saml-connection-modal';
import {
  TryConnectDrawer,
  TryStreamDrawer,
} from 'features/try-apps/try-app-drawers';
import { AddAppsDrawer } from 'features/user-group/user-group-tabs/components/AddAppsDrawer';
import { CreateTeamDrawer } from 'features/user-groups/components/CreateTeamDrawer/CreateTeamDrawer';
import { AddMembersDrawer } from 'features/user-group/user-group-details/components/AddMembersDrawer';
import { AddToTeamsDrawer } from 'features/members/components/table/components/AddToTeamsDrawer';
import { AddAppsToMemberDrawer } from 'features/members/components/table/components/AddAppsToMemberDrawer';
import { GoLiveDateDrawer } from 'features/main/components/GoLiveDateDrawer';

type DrawerId = keyof typeof DrawerMap;
// TODO We need to decouple feature state from the drawer, as we do with SNOW
type DrawerState = {
  drawerVisible: boolean;
  drawerId: string;
  data?: {
    connectionId?: string;
    ssoProvider?: string;
    [key: string]: any;
  } | null;
};
type DrawerAction = { type: string; payload?: any };

const DrawerMap = {
  'tenant-drawer': TenantsDrawer,
  'help-drawer': HelpDrawerController,
  'invite-details-drawer': InviteDetailsDrawer,
  'invite-drawer': InviteDrawer,
  'create-team-drawer': CreateTeamDrawer,
  'add-sso-connection-drawer': AddConnectionDrawer,
  'create-support-case-drawer': () => null,
  'sso-saml-connection-modal': SSOSamlConnectionModal,
  'try-connect': TryConnectDrawer,
  'try-ai': TryStreamDrawer,
  'add-apps-drawer': AddAppsDrawer,
  'add-members-drawer': AddMembersDrawer,
  'add-member-to-teams-drawer': AddToTeamsDrawer,
  'add-apps-to-member-drawer': AddAppsToMemberDrawer,
  'go-live-date-drawer': GoLiveDateDrawer,
  default: () => null,
  null: () => null,
};

export { DrawerId, DrawerState, DrawerAction, DrawerMap };
